import TYPES from '../actions/types';

const INITIAL_STATE = {
  detail: null,
}

const detailsLayer = function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TYPES.detailLayer:
      return { ...state, detail: action.payload }

    default:
      return state;
  }
}

export default detailsLayer;
